import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Inside from "./Inside";
import {
  useExchangeToken,
  useExchangeTokenSimCertAuditExecution,
} from "../actions/auth";
import { MENU_ITEMS, getAccessForRoles } from "../config/menuAccess";
import tuvNordLogo from "../img/TUEV-NORD_Logo_Electric-Blue_sRGB.jpg";
import "./Welcome.css";

// Menus intentionally kept out of the Welcome quick-access grid.
const EXCLUDED_SHORTCUTS = ["dashboard", "welcome", "scheduleMatrix"];

// Landing page for roles without dashboard access. Intentionally fetches NO
// data — it only reads the current user from the store and renders shortcuts to
// whatever menus the user is allowed to open.
export function Welcome({ user }) {
  const roles = user?.data?.role || [];
  const displayName = user?.data?.display_name || user?.username || "there";

  const access = getAccessForRoles(roles);

  const token = user?.access?.access_token;
  const userId = user?.id;

  // External modules open a separate app via token exchange (same as sidebar).
  const exchangeAuditExecution = useExchangeTokenSimCertAuditExecution({
    token,
    userId,
  });
  const exchangeAdvanceScheduling = useExchangeToken({ token, userId });

  const externalHandlers = {
    "audit-execution": exchangeAuditExecution,
    "advance-scheduling": exchangeAdvanceScheduling,
  };

  // Top-level menus this user may open, excluding the landing pages and
  // Schedule Matrix. External (token-exchange) modules are included.
  const shortcuts = MENU_ITEMS.filter(
    (item) =>
      access.includes(item.id) && !EXCLUDED_SHORTCUTS.includes(item.id),
  );

  function renderCardBody(item) {
    return (
      <>
        <span className="welcome-card__icon">
          <i className={item.icon || "fa fa-folder"} />
        </span>
        <span className="welcome-card__title">{item.title}</span>
      </>
    );
  }

  return (
    <Inside>
      <Helmet>
        <title>Welcome to SIMCert</title>
      </Helmet>

      <div className="content welcome-page">
        <div className="welcome-hero">
          <div className="welcome-hero__logo">
            <img src={tuvNordLogo} alt="T&Uuml;V NORD" />
          </div>
          <h1 className="welcome-hero__title">Welcome to SIMCert</h1>
          <p className="welcome-hero__subtitle">
            Sistem Informasi Manajemen Certification &mdash; T&Uuml;V NORD
            Indonesia
          </p>
          <p className="welcome-hero__greeting">
            Hello, <strong>{displayName}</strong>
            {roles.length > 0 && (
              <span className="welcome-hero__roles">
                {roles.map((r) => (
                  <span key={r} className="welcome-role-badge">
                    {r}
                  </span>
                ))}
              </span>
            )}
          </p>
        </div>

        <div className="main-content">
          {shortcuts.length > 0 ? (
            <>
              <h3 className="welcome-section-title">Quick access</h3>
              <div className="welcome-grid">
                {shortcuts.map((item) =>
                  item.external ? (
                    <div
                      key={item.id}
                      className="welcome-card"
                      onClick={externalHandlers[item.id]}
                    >
                      {renderCardBody(item)}
                    </div>
                  ) : (
                    <Link key={item.id} to={item.url} className="welcome-card">
                      {renderCardBody(item)}
                    </Link>
                  ),
                )}
              </div>
            </>
          ) : (
            <p className="welcome-empty">
              Belum ada modul yang tersedia untuk akun Anda. Silakan hubungi
              administrator jika ini tidak sesuai.
            </p>
          )}
        </div>
      </div>
    </Inside>
  );
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
  };
}

export default connect(mapStateToProps)(Welcome);